import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export default function Profile() {
  // const [name, nameState] = useState("");
  // const [email, emailState] = useState("");
  // const [address, addressState] = useState("");
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    address: "",
  });
  const history = useNavigate();
  //const accessToken = localStorage.getItem("jwt");

  //get profile details
  const getProfile = async () => {
    try {
      const res = await axios({
        url: "/api/user/details",
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      if (res.status == 200) {
        // console.log(res.data.message);
        //setUserData(res.data.data);
        setUserData({
          ...userData,
          name: res.data.data.name,
          email: res.data.data.email,
          address: res.data.data.address,
        });
      } else {
        toast.error(res.data.message);
      }
      //console.log("user_data", res.data.data.name);
    } catch (err) {
      console.log(err);
      history("/");
    }
    //console.log("function called");
  };

  const handleInputs = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    //console.log("name=> ", name, "   value=>", value);
    setUserData({
      ...userData,
      [name]: value,
    });
  };

  //send data to backend
  const accessToken = JSON.parse(localStorage.getItem("jwt"));
  const updatePofile = async (event) => {
    console.log("submitted");
    event.preventDefault();
    const { name, email, address } = userData;
    const res = await axios({
      url: "/api/user/update",
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        name: name,
        email: email,
        address: address,
      },
    });
    console.log("result", res);
    if (res.data.status === 200) {
      toast.success(res.data.message);
    } else {
      toast.error(res.data.message);
    }
    console.log(res);
  };

  useEffect(() => {
    getProfile();
  }, []);
  return (
    <React.Fragment>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <h4 className="Title">My Profile</h4>
            <form method="POST">
              <div className="PasswordArea">
                <div className="row">
                  <div className="col-sm-7">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        value={userData.name}
                        onChange={handleInputs}
                        name="name"
                        className="form-control"
                        placeholder="Enter Name"
                      />
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        value={userData.email}
                        onChange={handleInputs}
                        name="email"
                        className="form-control"
                        placeholder="Enter Email"
                        readOnly
                      />
                    </div>
                    <div className="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        value={userData.address}
                        onChange={handleInputs}
                        name="address"
                        className="form-control"
                        placeholder="Enter Address"
                      />
                    </div>
                    <button onClick={updatePofile}>Submit</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
